export const SECTIONS_IDS = {
  marketOverview: 'market-overview',
  behavioralTrends: 'behavioral-trends',
  shareOfScreenTime: 'share-of-screen-time',
  marketBehavior: 'market-behavior',
  screenTimeBySector: 'screen-time-by-sector',
  appTrends: 'app-trends',
  aiAppImpact: 'ai-app-impact',
};

export const SECTIONS = [
  {
    id: SECTIONS_IDS.marketOverview,
    label: 'Market Overview',
    tooltip:
      'Track the growth of DAUs and Downloads of the AI app market. See which apps are taking share.',
  },
  {
    id: SECTIONS_IDS.behavioralTrends,
    label: 'Behavioral Trends',
    tooltip: 'Track AI user behaviors and quantify the impact of AI apps on non-AI sectors.',
  },
  {
    id: SECTIONS_IDS.shareOfScreenTime,
    label: 'AI Screen Time',
    tooltip:
      'Shows how much of total user attention AI apps capture compared to all other apps in thepanel.',
  },
  {
    id: SECTIONS_IDS.marketBehavior,
    label: 'AI User Segmentation',
    tooltip: 'Identifies key AI user types and tracks the flow of these users.',
  },
  {
    id: SECTIONS_IDS.screenTimeBySector,
    label: 'AI User Impact by Sector',
    tooltip:
      'Highlights how time spent by medium and high-frequency AI users is changing across sectors and where their attention is concentrated.',
  },
  {
    id: SECTIONS_IDS.appTrends,
    label: 'App Trends',
    tooltip:
      'Explore engagement patterns for a selected AI app and how different segments interact with it.',
  },
  {
    id: SECTIONS_IDS.aiAppImpact,
    label: 'AI App Impact',
    tooltip: 'Measures how AI adoption influences behavior across the broader app ecosystem.',
  },
];
